import { Link } from 'react-router-dom';

export default function Footer() {
  const footerLinks = [
    {
      title: '热门分类',
      links: [
        { label: '网红爆料', to: '/category/wanghong' },
        { label: '明星黑料', to: '/category/mingxing' },
        { label: '反差视频', to: '/category/shipin' },
        { label: '社会大瓜', to: '/category/shehui' },
        { label: '直播翻车', to: '/category/zhibo' },
        { label: '独家深扒', to: '/category/shenba' },
      ],
    },
    {
      title: '快速导航',
      links: [
        { label: '首页', to: '/' },
        { label: '最新爆料', to: '/#latest' },
        { label: '热门黑料', to: '/#hot' },
        { label: '关于我们', to: '/about' },
        { label: '下载APP', to: '/#download' },
      ],
    },
    {
      title: '关于暗网吃瓜',
      links: [
        { label: '品牌介绍', to: '/about' },
        { label: '用户评价', to: '/about#reputation' },
        { label: '联系我们', to: '/about#contact' },
        { label: '隐私政策', to: '/about' },
        { label: '免责声明', to: '/about' },
      ],
    },
    {
      title: '关注我们',
      links: [
        { label: '微信公众号', to: '/about#contact' },
        { label: '新浪微博', to: '/about#contact' },
        { label: '抖音号', to: '/about#contact' },
        { label: '小红书', to: '/about#contact' },
        { label: 'B站', to: '/about#contact' },
      ],
    },
  ];

  return (
    <footer className="bg-background-100 border-t border-background-300/30">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 max-w-6xl mx-auto">
          {footerLinks.map((section) => (
            <div key={section.title}>
              <h4 className="text-foreground-100 font-medium text-sm mb-5 pb-3 border-b border-primary-500/30">
                {section.title}
              </h4>
              <ul className="flex flex-col gap-3">
                {section.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-foreground-500 hover:text-foreground-200 text-sm transition-colors duration-200"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <div className="border-t border-background-300/20">
        <div className="w-full px-4 md:px-6 py-10">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-6 max-w-6xl mx-auto">
            <div className="flex flex-col items-center sm:items-start gap-1">
              <h2 className="font-heading text-3xl text-foreground-50 tracking-wider leading-tight">
                暗网吃瓜
              </h2>
              <p className="font-heading text-2xl text-foreground-400 tracking-wider opacity-60 leading-tight">
                吃瓜不迷路
              </p>
              <span className="text-foreground-600 text-xs mt-1">— 实时爆料 一手掌握 —</span>
            </div>

            <div className="flex items-center gap-4">
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full bg-background-200 text-foreground-400 hover:text-accent-500 hover:bg-background-300 transition-all duration-200" aria-label="微博">
                <i className="ri-weibo-line text-lg w-4 h-4 flex items-center justify-center"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full bg-background-200 text-foreground-400 hover:text-accent-500 hover:bg-background-300 transition-all duration-200" aria-label="微信">
                <i className="ri-wechat-line text-lg w-4 h-4 flex items-center justify-center"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full bg-background-200 text-foreground-400 hover:text-accent-500 hover:bg-background-300 transition-all duration-200" aria-label="抖音">
                <i className="ri-tiktok-line text-lg w-4 h-4 flex items-center justify-center"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full bg-background-200 text-foreground-400 hover:text-accent-500 hover:bg-background-300 transition-all duration-200" aria-label="B站">
                <i className="ri-bilibili-line text-lg w-4 h-4 flex items-center justify-center"></i>
              </a>
            </div>
          </div>

          <div className="text-center mt-8">
            <p className="text-foreground-600 text-xs">
              &copy; {new Date().getFullYear()} 暗网吃瓜 版权所有 | 本站内容仅供娱乐参考，如有不实信息请联系删除
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}